import { useState } from "react";
import { useDispatch } from "react-redux";

import AppointmentsMainLeftPart from "../AppointmentsMainLeftPart/AppointmentsMainLeftPart";
import AppointmentsMainRightPart from "../AppointmentsMainRightPart/AppointmentsMainRightPart";
import AppointmentsSearchDrayer from "../AppointmentsSearchDrayer/AppointmentsSearchDrawer";
import AppointmentsDrawerAddService from "../AppointmentsDrawerAddService/AppointmentsDrawerAddService";
import useGetRole from "@/hooks/useGetRole";
import { toast } from "react-toastify";
import { dateFormatter } from "@/utils/dateFormatter";

import "./AppointmentsMain.scss";
import { setPatientsBirthDay } from "@/store/patients/patients";

export default function AppointmentsMain() {
    const [open, setOpen] = useState<boolean>(false);
    const [isExistuser, setIsExistUser] = useState<boolean>(true);
    const { isAdmin } = useGetRole();
    const dispatch = useDispatch();

    function toggleDrawer(isOpen: boolean): void {
        if (isAdmin) {
            setOpen(isOpen);
            setIsExistUser(true);
            dispatch(setPatientsBirthDay(dateFormatter(new Date())));
        } else toast.error("Зверніться до адміністатора!");
    }

    function toggleExistUser(isExist: boolean): void {
        setIsExistUser(isExist);
    }
    return (
        <>
            <main className='appointment_main'>
                <AppointmentsMainLeftPart toggleDrawer={toggleDrawer} />
                <AppointmentsMainRightPart />
            </main>
            <AppointmentsSearchDrayer
                toggleDrawer={toggleDrawer}
                open={open}
                toggleExistUser={toggleExistUser}
                isExistuser={isExistuser}
            />
            <AppointmentsDrawerAddService />
        </>
    );
}
